import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./assets/css/main.scss";
import './i18n';

import AdminDashboard from "./pages/AdminDashboard";
import DifferenceDashboard from "./pages/DifferenceDashboard";
import Consumer from "./pages/Consumer";
import ConsumerCashbacks from "./pages/ConsumerCashbacks";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Retailer from "./pages/Retailer";
import RetailerCashbacks from "./pages/RetailerCashbacks";
import RetailerDashboard from "./pages/RetailerDashboard";
import RetailersPrivacyPolicy from "./pages/RetailersPrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import AdminLogin from "./pages/AdminLogin";
import { HelmetProvider } from 'react-helmet-async';
import PayoutsDashboard from "./pages/PayoutsDashboard";
import AdminDashboardPhase2 from "./pages/AdminDashboardPhase2";
import RetailerDashboardPhase2 from "./pages/RetailerDashboardPhase2";
import ConsumerLogin from "./pages/ConsumerLogin";
import ConsumerLoginCashbacks from "./pages/ConsumerLoginCashbacks";


function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<ConsumerLogin />} />
          {/* <Route path="/" element={<Consumer />} /> */}
          <Route path="/consumer/cashbacks" element={<ConsumerLoginCashbacks />} />
          {/* <Route path="/consumer/cashbacks" element={<ConsumerCashbacks />} /> */}

          <Route path="/retailers/login" element={<Retailer />} />
          <Route path="/retailers/register" element={<Retailer />} />
          <Route path="/retailers/cashbacks" element={<RetailerCashbacks />} />
          {/* <Route path="/retailers/dashboard" element={<RetailerDashboard />} /> */}
          <Route path="/retailers/dashboard" element={<RetailerDashboardPhase2 />} />
          <Route path="/retailers/privacy-policy" element={<RetailersPrivacyPolicy />} />

          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/phase-2/admin/dashboard" element={<AdminDashboardPhase2 />} />
          <Route path="/payouts" element={<PayoutsDashboard />} />
          <Route path="/admin/difference-dashboard" element={<DifferenceDashboard />} />

          {/* <Route path="/admin/login" element={<AdminLogin />} /> */}
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="*" element={<NotFound />} />

        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
